import { render, staticRenderFns } from "./BiDashboard.vue?vue&type=template&id=4dc53413"
import script from "./BiDashboard.vue?vue&type=script&lang=js"
export * from "./BiDashboard.vue?vue&type=script&lang=js"
import style0 from "./BiDashboard.vue?vue&type=style&index=0&id=4dc53413&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports